enum DesignDialogFields {
	THEME = "theme",
	THEME_CONTENT = "theme_content",
	LOGO = "logo",
	LOGO_FILE = "logo_file",
	BACKGROUND = "background",
	BACKGROUND_FILE = "background_file",
	BACKGROUND_HIDE = "background_hide"
}

export default DesignDialogFields;